export default __webpack_public_path__ + "static/media/GabrielaSalvador.91a7ff97.png";